export default __webpack_public_path__ + "static/assets/f67b66443b70cdc01a355630b68e8c01.png";